import React from 'react';

export function SplashScreen() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-green-50 via-white to-blue-50 z-50 flex items-center justify-center">
      <div className="animate-fade-in flex flex-col items-center gap-6">
        <img
          src="/clean-up-britain-logo-topaz-sharpen.png"
          alt="Clean Up Britain"
          className="w-40 h-40 sm:w-48 sm:h-48 object-contain drop-shadow-lg"
        />
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse [animation-delay:150ms]" />
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  );
}